import { createTypedHooks } from "easy-peasy";
import { StoreModel } from "../store/store";

export const { useStoreActions, useStoreState, useStoreDispatch, useStore } =
  createTypedHooks<StoreModel>();
